import React from "react";
import AppBar from "components/Layout/AppBar";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Opreation from "../assets/img/img1.svg";
import ContentImg from "../assets/img/img2.svg";
import ContentImg3 from "../assets/img/img3.svg";
import ContentImg4 from "../assets/img/img4.svg";
import ContentImg5 from "../assets/img/img5.svg";
import { Routes, Route } from "react-router-dom";
const CreateAccount = React.lazy(() =>
  import("../features/accountCreation")
);
import { Loading } from "../components/Ui";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Store from "_Store";
import ReportDialog from "pages/Report/ReportDialog";
import useCampaignData from "hooks/useCampaignData";
import { useFarmData } from "hooks/useFarmData";

const Dashboard = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const { data: campaigns } = useCampaignData();
  const { data: farms } = useFarmData();

  const handleOpenDialog = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const {
    setUtils
  } = React.useContext(Store);

  const handleNavigate = (path) => {
    navigate(path);
  };

  useEffect(() => {
    setUtils("loading", { spinning: false, primary: "" });
  }, []);

  return (
    <>
      <div className="w-full sm:max-w-screen-2xl sm:px-6 mx-auto flex flex-col">
        <div className="pt-4">
          <AppBar />
        </div>
        <Box sx={{ flexGrow: 1, py: 10 }} className="content_disponibles">
          <h4>Outils disponibles</h4>
          <Grid
            container
            spacing={2}
            sx={{ flexGrow: 1, py: 10 }}
            style={{ justifyContent: "center", gap: "15px" }}
          >
            {farms && farms.length > 0 ? <>
            <Box
              className="user_content"
              component="span"
              onClick={() =>
                handleNavigate(
                  campaigns && campaigns.length > 0 ? "/campaigns" : "/campaigns/add"
                )
              }
            >
              <div className="user_content_img">
                <img src={Opreation} />
              </div>
              <p>
                Fiche de plan de campagne{" "}
                <span>
                  <ArrowForwardIosIcon />
                </span>
              </p>
            </Box>
            <Box
              className="user_content"
              component="span"
              onClick={() => handleNavigate("/operations")}
            >
              <div className="user_content_img">
                <img src={ContentImg3} />
              </div>
              <p>
                Fiche de réalisation des opérations
                <span>
                  <ArrowForwardIosIcon />
                </span>
              </p>
            </Box>
            </> : null }
            <Box
              className="user_content"
              component="span"
              onClick={() => handleNavigate("/stock-sheet")}
            >
              <div className="user_content_img">
                <img src={ContentImg} />
              </div>
              <p>
                Fiche de stock{" "}
                <span>
                  <ArrowForwardIosIcon />
                </span>
              </p>
            </Box>
            <Box
              className="user_content"
              component="span"
              onClick={() => handleNavigate("/cahier-sheet")}
            >
              <div className="user_content_img">
                <img src={ContentImg4} />
              </div>
              <p>
                Journal de caisse{" "}
                <span>
                  <ArrowForwardIosIcon />
                </span>
              </p>
            </Box>
            <Box
              className="user_content"
              component="span"
              onClick={() => handleOpenDialog()}
            >
              <div className="user_content_img">
                <img src={ContentImg5} />
              </div>
              <p>
                Rapport{" "}
                <span>
                  <ArrowForwardIosIcon />
                </span>
              </p>
            </Box>
          </Grid>
        </Box>
      </div>
      <ReportDialog
        open={open}
        handleClose={handleClose}
        handleNavigate={handleNavigate}
      />
    </>
  );
};

export default Dashboard;
